import RateplanForm from '../screens/RateplanForm'
import RateplanTabs from '../screens/RateplanTabs'
import RateplansList from '../screens/RateplansList'
import { allRoles, ROLE, RouteWithAccessType } from './types'

const ratePlanPagesRoleManagement: RouteWithAccessType[] = [
  {
    route: '/accommodations/:accommodationID/:propertyCode/rate-plans/list',
    exact: true,
    rolesListWithReadAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.TENANT,
      ROLE.ACCOMMODATION,
      ROLE.ACCOMMODATION_OPERATOR,
      ROLE.TENANT_MARKETING,
      ROLE.PROVIDER_MARKETING,
      ROLE.TENANT_IT,
      ROLE.PROVIDER_IT,
      ROLE.TENANT_MANAGEMENT,
      ROLE.CHANNEL_ACTIVATION
    ],
    rolesListWithWriteAccess: [
      ROLE.ADMIN,
      ROLE.PROVIDER,
      ROLE.TENANT,
      ROLE.ACCOMMODATION,
      ROLE.TENANT_MARKETING,
      ROLE.CHANNEL_ACTIVATION
    ],
    requiredFeatures: ['rateplan.list.view'],
    component: <RateplansList />
  },
  {
    route:
      '/accommodations/:accommodationID/:propertyCode/room-type/:roomTypeID/rate-plans/:id/providerCode/:providerCode/:page',
    exact: true,
    rolesListWithReadAccess: allRoles,
    rolesListWithWriteAccess: allRoles,
    requiredFeatures: ['rateplan.list.view'],
    component: <RateplanTabs />,
    tabs: [
      {
        params: { page: 'details' },
        rolesListWithReadAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.PROVIDER_MARKETING,
          ROLE.PROVIDER_IT,
          ROLE.PROVIDER_FINANCE,
          ROLE.PROVIDER_MANAGEMENT,
          ROLE.ACCOMMODATION,
          ROLE.CHANNEL,
          ROLE.CHANNEL_ADMIN,
          ROLE.TENANT,
          ROLE.TENANT_MARKETING,
          ROLE.TENANT_IT,
          ROLE.TENANT_MANAGEMENT,
          ROLE.CHANNEL_ACTIVATION
        ],
        rolesListWithWriteAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.PROVIDER_MARKETING,
          ROLE.TENANT,
          ROLE.CHANNEL_ACTIVATION
        ],
        requiredFeatures: ['rateplan.details.view']
      },
      {
        params: { page: 'policies' },
        rolesListWithReadAccess: [
          ROLE.ADMIN,
          ROLE.PROVIDER,
          ROLE.PROVIDER_MARKETING,
          ROLE.PROVIDER_IT,
          ROLE.PROVIDER_FINANCE,
          ROLE.PROVIDER_MANAGEMENT,
          ROLE.ACCOMMODATION,
          ROLE.CHANNEL,
          ROLE.CHANNEL_ADMIN,
          ROLE.TENANT,
          ROLE.TENANT_MARKETING,
          ROLE.TENANT_IT,
          ROLE.TENANT_MANAGEMENT,
          ROLE.CHANNEL_ACTIVATION
        ],
        rolesListWithWriteAccess: [ROLE.ADMIN],
        requiredFeatures: ['rateplan.policies.manage']
      }
    ]
  },
  {
    route: '/accommodations/:accommodationID/:propertyCode/rate-plans/create',
    exact: true,
    rolesListWithReadAccess: [ROLE.ADMIN, ROLE.CHANNEL_ACTIVATION],
    rolesListWithWriteAccess: [ROLE.ADMIN, ROLE.CHANNEL_ACTIVATION],
    requiredFeatures: ['rateplan.create'],
    component: <RateplanForm />
  }
]

export default ratePlanPagesRoleManagement
